import { useState, useEffect, useCallback } from "react";
import { getCurrentSpentChart } from "../../api/finances/spendingsAPI";

const createInitialChartData = () => ({
  current_month_name: "",
  previous_month_name: "",
  current_total_spent: 0,
  previous_total_on_same_day: 0,
  chart_data: {
    current_month: [],
    previous_month: [],
    average_data: [],
  },
});

export function useSpendingUsage(is_data_ready = true) {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [spendingData, setSpendingData] = useState(createInitialChartData());

  const loadSpendingData = useCallback(async () => {
    setIsLoading(true);
    setError("");

    try {
      const data = await getCurrentSpentChart();
      setSpendingData(data);
    } catch (err) {
      setSpendingData(createInitialChartData());
      setError("We could not load your spending chart. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (is_data_ready) {
      loadSpendingData();
    }
  }, [loadSpendingData]);

  // Return the raw data plus some "computed" shortcuts for easier use in components
  return {
    isLoading,
    error,
    spendingData,
    currentTotal: spendingData.current_total_spent,
    previousTotalOnSameDay: spendingData.previous_total_on_same_day,
    chartData: spendingData.chart_data,
    refresh: loadSpendingData, // Expose this so components can "Pull to refresh"
  };
}
